import { render, staticRenderFns } from "./SpecialAlerts.vue?vue&type=template&id=033314b4&scoped=true"
import script from "./SpecialAlerts.vue?vue&type=script&lang=js"
export * from "./SpecialAlerts.vue?vue&type=script&lang=js"
import style0 from "./SpecialAlerts.vue?vue&type=style&index=0&id=033314b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033314b4",
  null
  
)

export default component.exports